<block-ui></block-ui>
<!-- Page Content -->
<div *ngIf="ShowPageContent" class="container-fluid">
  <div class="card card-custom-h">
    <div class="card-header border-0 pt-5">
      <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
        <form [formGroup]="DepartmentForm">
          <BBSF-TextBox [options]="searchTextBox" [group]="DepartmentForm"></BBSF-TextBox>
        </form>
      </div>
      <div class="card-toolbar">
        <!-- begin::Menu -->
        <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddDepartmentModal(AddDepartmentModal)">
          <i class="fas fa-plus me-1"></i>
          {{UtilityService.getResourceValue("Add")}}
        </button>

        <!-- end::Menu -->
      </div>
    </div>
    <div class="card-body py-3">
      <div class="table-responsive">
        <!--begin::Permission list-->
        <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
          <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-150px">{{UtilityService.getResourceValue("Name")}}</th>
              <th class="min-w-150px">{{UtilityService.getResourceValue("SamAccount")}}</th>
              <th class="min-w-150px">{{UtilityService.getResourceValue("UsersCount")}}</th>
              <th class="min-w-50px">{{UtilityService.getResourceValue("Action")}}</th>
            </tr>
          </thead>
          <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

            <tr *ngFor="let Department of DepartmentPagingResult">

              <td>
                <a href="javascript:void(0)" [routerLink]="['/Admin/Departments/DepartmentInfo',Department.id]" routerLinkActive="router-link-active"
                   class="text-dark">{{Department.departmentName}}</a>

              </td>
              <td>{{Department.samAccount}}</td>
              <td>{{Department.usersCount}}</td>
              <td>
                <div>
                  <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button class="drop-item px-3" ngbDropdownItem
                            (click)="showEditDepartmentModal(Department.id,Department.idEncrypted,EditDepartmentModal)">
                      <span class="drop-link px-3">{{UtilityService.getResourceValue("Edit")}}</span>
                    </button>
                    <a ngbDropdownItem class="drop-item px-3"
                       (click)="showDeleteDepartmentModal(Department.idEncrypted)">
                      <span class="drop-link px-3">{{UtilityService.getResourceValue("Delete")}}</span>
                    </a>
                  </mat-menu>
                </div>

              </td>
            </tr>
            <tr *ngIf="DepartmentPagingResult.length == 0">
              <td colspan="4">
                <lib-empty-data></lib-empty-data>
              </td>
            </tr>
          </tbody>
        </table>

        <!--end::Permission list-->
      </div>

    </div>
    <div class="card-footer border-0">
      <BBSF-Paging (Items)="setDepartmentListResult($event)" *ngIf="IsFilterLoaded"
                   [options]="DepartmentPaging" [group]="DepartmentForm" #DepartmentPagingViewElement>
      </BBSF-Paging>
    </div>
  </div>

</div>

<!--add Modal-->
<ng-template #AddDepartmentModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3"> {{UtilityService.getResourceValue("Add")}} {{UtilityService.getResourceValue("Department")}}</h1>
    </div>
    <BBSF-Form [options]="AddDepartmentFormOptions">

      <div class="row">
        <div class="col-md-12">
          <BBSF-MultiLingualTextBox [options]="AddName" [group]="AddDepartmentForm"></BBSF-MultiLingualTextBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-TextBox [options]="AddSamAccount" [group]="AddDepartmentForm">
          </BBSF-TextBox>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDepartmentModal id="CloseDepartmentModal" type="button"
                class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
          {{UtilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="submit" class="btn btn-primary btn-sm">{{UtilityService.getResourceValue("SaveLabel")}}</button>
      </div>
    </BBSF-Form>
  </div>
</ng-template>
<!--Edit Modal-->
<ng-template #EditDepartmentModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{UtilityService.getResourceValue("Edit")}} {{UtilityService.getResourceValue("Department")}}</h1>
    </div>
    <BBSF-Form [options]="EditDepartmentFormOptions">
      <div class="row">
        <div class="col-md-12">
          <BBSF-MultiLingualTextBox [options]="EditName" [group]="EditDepartmentForm"></BBSF-MultiLingualTextBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-TextBox [options]="EditSamAccount" [group]="EditDepartmentForm">
          </BBSF-TextBox>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseEditDepartmentModal id="CloseEditDepartmentModal" type="button"
                class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
          {{UtilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="submit" class="btn btn-primary btn-sm">{{UtilityService.getResourceValue("SaveLabel")}}</button>
      </div>
    </BBSF-Form>
  </div>
</ng-template>

<!--delete confirmation modal-->
<BBSF-ConfirmationModal *ngIf="deleteControlLoaded" [options]="DeleteConfirmationOptions" id="ConfirmationModalControl" #ConfirmationModalControl></BBSF-ConfirmationModal>
